import { render } from "./InterventionDetails.vue?vue&type=template&id=6456cc57"
import script from "./InterventionDetails.vue?vue&type=script&lang=js"
export * from "./InterventionDetails.vue?vue&type=script&lang=js"

import "./InterventionDetails.vue?vue&type=style&index=0&id=6456cc57&lang=css"

import exportComponent from "/root/dirif/preprod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__